import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";
import * as amplify from "../util/amplify.ts";
import { validate } from "../util/forms.ts";
import * as Html from "../util/Html.ts";

import ApiServer from "../ApiServer.ts";
import * as DateUtils from "../lib/DateUtils.ts";
import TPL_MODALCOPY from "./modal_copyweek.mustache";
import TPL_MODALPLAN from "./modal_recipeplan.mustache";
import TPL_PICKTYPE from "./modal_pickmealtype.mustache";
 import Icons from "../svg/Icons.ts";
import { apiCustommplist, dishSyncCache, getWeekRange, MealplannerSettingsCache, mealSyncCache, updateMealplannerSettings } from "./mealplannerApi.ts";
import { TEMPLATE } from "../TEMPLATE.ts";

export {openCopyWeek,openRecipePlan}

export async function modalmealplannersettings(){
  return new Promise(async (resolve,reject)=>{
    const
      settings = await MealplannerSettingsCache.need(),
      TPL = await import("../mealplanner/modal_settings.mustache"),
      theModal = modal.openDomModal(TPL,settings);
    var
      changed = false,
      form = theModal.querySelector('form'),
      button = form.querySelector('button[data-fw-onclick=submit]');


    button.addEventListener('click', async function(){
      var settings = await MealplannerSettingsCache.need()


      form.display.forEach((checkbox)=>{
        settings.columns.find(c=>c.type===checkbox.getAttribute('data-type')).display = checkbox.checked;
      });
      form.emoji.forEach((input)=>{
        settings.columns.find(c=>c.type===input.getAttribute('data-type')).emoji = input.value;
      });
      form.nameSlot.forEach((input)=>{
        if(input.value==='') return;
        settings.columns.find(c=>c.type===input.getAttribute('data-type')).name = input.value;
      });
      form.timeSlot.forEach((input)=>{
        if(input.value.length){
          settings.columns.find(c=>c.type===input.getAttribute('data-type')).timeSlot = input.value;
        }
      });
      await updateMealplannerSettings(settings)
      changed = true;
      modal.closeDomModal(theModal);
    })
    theModal.onClose = ()=>{resolve(changed)}
  })
}


function openCopyWeek(targetDate :Date,weekSourceDate :Date){
  var
    range = getWeekRange(weekSourceDate),
    theModal :modal.DomModal;
  function update(){
    apiCustommplist(range).then(function(mplistResponse){
      modal.closeDomModal(theModal)
      theModal = modal.openDomModal(TPL_MODALCOPY,{
        range:range,
        days:mplistResponse.days
      });

      const prevWeekBtn = theModal.querySelector('[data-fw-onclick="mpprevweek"]');
      if(prevWeekBtn){
        prevWeekBtn.addEventListener('click', ()=>{
          range=getWeekRange(range.prev);
          update()
        });
        prevWeekBtn.removeAttribute('data-fw-onclick');
        (prevWeekBtn as HTMLElement).style.cursor = 'pointer';
      }

      const nextWeekBtn = theModal.querySelector('[data-fw-onclick="mpnextweek"]');
      if(nextWeekBtn){
        nextWeekBtn.addEventListener('click', ()=>{
          range=getWeekRange(range.next);
          update()
        });
        nextWeekBtn.removeAttribute('data-fw-onclick');
        (nextWeekBtn as HTMLElement).style.cursor = 'pointer';
      }

      const submitBtn = theModal.querySelector('[data-fw-onclick="submit"]');
      if(submitBtn){
        submitBtn.addEventListener('click', async ()=>{
          function doit(){
            ApiServer.mpcopy(DateUtils.forInputDate(range.start),DateUtils.forInputDate(range.end),DateUtils.forInputDate(targetDate),async function(createdDishes){
              modal.closeDomModal(theModal);
              amplify.publish('dishChange');
              if(await modal.toastUndo({svg:Icons.ic_done,text:"mp.copysuccess"})){
                ApiServer.metadelete(createdDishes.map(dish=>dish.metaId))
                dishSyncCache.invalidate();
                amplify.publish('dishChange');
              }
            })
            dishSyncCache.invalidate();
          }
          if(mplistResponse.list.length===0){
            modal.closeDomModal(theModal);
            modal.toast({text:"mp.copyempty"});
          }else if(DateUtils.forInputDate(range.start)==DateUtils.forInputDate(targetDate)){
            if(await modal.confirm("mp.copyconfirmself")){
              doit()
            }
          }else{
            doit()
          }
        });
        submitBtn.removeAttribute('data-fw-onclick');
        (submitBtn as HTMLElement).style.cursor = 'pointer';
      }
    })
  }
  update()
}


function openRecipePlan(recipeId :string){
  var
    range = getWeekRange(new Date()),
    theModal :modal.DomModal;
  function update(){
    apiCustommplist(range).then(function(mplistResponse){
      modal.closeDomModal(theModal)
      theModal = modal.openDomModal(TPL_MODALPLAN,{
        range:range,
        days:mplistResponse.days
      });

      const prevWeekBtn = theModal.querySelector('[data-fw-onclick="mpprevweek"]');
      if(prevWeekBtn){
        prevWeekBtn.addEventListener('click', ()=>{
          range=getWeekRange(range.prev);
          update()
        });
        prevWeekBtn.removeAttribute('data-fw-onclick');
        (prevWeekBtn as HTMLElement).style.cursor = 'pointer';
      }

      const nextWeekBtn = theModal.querySelector('[data-fw-onclick="mpnextweek"]');
      if(nextWeekBtn){
        nextWeekBtn.addEventListener('click', ()=>{
          range=getWeekRange(range.next);
          update()
        });
        nextWeekBtn.removeAttribute('data-fw-onclick');
        (nextWeekBtn as HTMLElement).style.cursor = 'pointer';
      }

      theModal.querySelectorAll<HTMLElement>('[data-day]').forEach(dayElement => {
        dayElement.addEventListener('click', async function(){
          const day = (this as HTMLElement).getAttribute('data-day');
          const mealtype = await openPickMealType();
          const mealplannerSettings = await MealplannerSettingsCache.need();

          if(mealtype){
            ApiServer.mprecipeput(new ApiServer.types.RecipeInputBean({metaId:recipeId,isMealSuggestion:true}))
            ApiServer.mpcreateByRecipeId(recipeId,day,mealtype,function(){
              modal.closeDomModal(theModal);

              const mealTypeName = mealplannerSettings.columns.find(col=>col.type===mealtype).displayName;
              const dayName = DateUtils.toLocaleString(new Date(day),{month: 'long', day: 'numeric' });
              const text = i18n.get('mp.recipeplanned',{mealTypeName,dayName})

              modal.toast({svg:Icons.ic_done,text});
            })
            dishSyncCache.invalidate()
          }
        });
        (dayElement as HTMLElement).style.cursor = 'pointer';
      });
    })
  }
  update()
}

function openPickMealType(){
  return new Promise((resolve,reject)=>{
    ApiServer.mpsettingsget(settings=>{
      const theModal = modal.openDomModal(TPL_PICKTYPE,settings);
      theModal.querySelectorAll<HTMLElement>("[data-type]").forEach(element => {
        element.addEventListener("click", function(){
          resolve((this as HTMLElement).getAttribute("data-type"))
          theModal.onClose = undefined;
          modal.closeDomModal(theModal)
        })
      });
      theModal.onClose = ()=>{resolve(null)}
    })
  })
}

export async function modalMeal(date :Date|undefined, type:string|undefined){
  const meal = mealSyncCache.datas.find(meal=>meal.date===date && meal.type===type) || {date:DateUtils.forInputDate(date),type};
  const theModal = modal.openDomModal(await import('./modal_mealcreate.mustache'),{
    settings:await MealplannerSettingsCache.need(),
    meal
  });

  const form = theModal.querySelector('form') as HTMLFormElement;
  const dateInput = form.querySelector('[name=date]') as HTMLInputElement;
  const servesInput = form.querySelector('[name=serves]') as HTMLSelectElement;
  const noteInput = form.querySelector('[name=note]') as HTMLTextAreaElement;
  const typeInput = form.querySelector('[name=type]') as HTMLSelectElement;

  const options = {0:i18n.get('labels.none')};
  for(let i=1;i<100;i++){
    options[i] = i.toString()
  }
  servesInput.innerHTML = Object.entries(options).map(([key,val])=>TEMPLATE`<option value="${key}">${val}</option>`).join('');
  servesInput.value = servesInput.getAttribute('value') || '0';
  typeInput.value = typeInput.getAttribute('value') || 'LUNCH';

  function loadMeal(){
    const date = dateInput.value;
    const type = typeInput.value;
    const theMeal = mealSyncCache.datas.find(meal=>meal.date===date && meal.type===type);

    if(theMeal){
      servesInput.value = theMeal.serves;
      noteInput.value = theMeal.note;
    }else{
      servesInput.value = '0';
      noteInput.value = '';
    }
  }

  dateInput.addEventListener('change', loadMeal);
  typeInput.addEventListener('change', loadMeal);

  form.addEventListener('submit', function(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    if(!validate(form)){
      return false;
    }

    const dishInput = form.querySelector('[name=dish]') as HTMLInputElement;
    const dish = dishInput.value;
    const date = dateInput.value;
    const type = typeInput.value;
    const serves = servesInput.value;
    const note = noteInput.value;

    if(serves||note){
      ApiServer.mpmealput({date,type,serves,note});
      mealSyncCache.invalidate()
    }
    if(dish){
      ApiServer.mpcreate([dish],date,type);
      dishSyncCache.invalidate()
    }
    modal.closeDomModal(theModal)
    amplify.publish('dishChange')
  });
  return theModal
}

export async function modalMealEditSimple(date :string, type:string){
  const meal = mealSyncCache.datas.find(meal=>meal.date===date && meal.type===type);
  const theModal = modal.openDomModal(await import('./modal_mealedit.mustache'),{
    meal
  });

  const form = theModal.querySelector('form') as HTMLFormElement;
  const servesInput = form.querySelector('[name=serves]') as HTMLSelectElement;
  const noteInput = form.querySelector('[name=note]') as HTMLTextAreaElement;

  const options = {0:i18n.get('labels.none')};
  for(let i=1;i<100;i++){
    options[i] = i.toString()
  }
  servesInput.innerHTML = Object.entries(options).map(([key,val])=>TEMPLATE`<option value="${key}">${val}</option>`).join('');
  servesInput.value = servesInput.getAttribute('value') || '0';

  form.addEventListener('submit', function(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    if(!validate(form)){
      return false;
    }

    const serves = servesInput.value;
    const note = noteInput.value;

    if(serves||note){
      ApiServer.mpmealput({date,type,serves,note});
      mealSyncCache.invalidate()
    }
    modal.closeDomModal(theModal)
    amplify.publish('dishChange')
  });
  return theModal
}
Html.registerDom({
  mpmealcreate(){
    modalMeal(new Date(),'LUNCH')
  },
  mpmealedit(){
    // this est déjà un HTMLElement avec registerDom
    modalMealEditSimple(
      this.closest('[date]').getAttribute('date'),
      this.closest('[dishtypeenum]').getAttribute('dishtypeenum')
    )
    return true;
  }

})
